import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getSubscribersListPaged, getTotalSubscribers, exportWcSubscribers,removethisItem,
  getjobs, getTotalApplicants 
} from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

 
const IMGURL = "https://bewiseblobprod.blob.core.windows.net/assets/bewise/uploads/";


import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';


class Wcdashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export',
      jobList:[],
       
      totaljobposted:0,
      totalapplicants:0
    }

    
    
  }



  componentDidMount() {

    const { login_id, role, profilepicture } = this.state.auth_data;

    this.user_id = login_id;
    this.getJobs();
    this.getTotalApplicants();
    
  }

 


 
  getTotalApplicants(){

    let req = JSON.stringify({
        user_id:this.user_id,
    })
    
    getTotalApplicants(req).then((response) => {
      
      if(response.status==1){
            
            this.setState({ totalapplicants:response.totalapplicants});

      } 

    });

  }
  
  

  getJobs(){

    let req = JSON.stringify({
        user_id:this.user_id,
    })
    
    getjobs(req).then((response) => {
      
      if(response.status==1){
            
            this.setState({jobList:response.list, totaljobposted:response.list.length});

      } 
      
    });

  }
  
  
 
  render() {
 
    const profilepicture = this.state.auth_data.profilepicture;
    const organisation = this.state.auth_data.organisation;

    const {value,totaljobposted, totalapplicants, suggestions, pickedones, jobList} = this.state;
       
    return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                    <div class="org_name_full_width">Organisation:<span>{organisation}</span></div>
                    <div class="content-section contenttop borderedbox">
                    
                       

                    <div class="insprofilephoto">
                           <img src={IMGURL+profilepicture} />
                         

                    </div>

                    <div class="currentlyhiring purplebox">
                               <div class="textDark">Currently hiring for</div>
                               <div class="textDark largNumber">{totaljobposted}</div>
                               <div class="textnormal">roles</div>
                    </div> 


                    <div class="noofapplicants purplebox">
                    <div class="textDark">No of applicants</div>
                               <div class="textDark largNumber">{totalapplicants}</div>
                               <div class="textnormal">applicants</div>
                     </div>                   
                     <div class="buttonsec_lg">
                              
                             <div><a href="/partner/wcpostajob" class="btn btn-main-full">Post job</a></div>
                     </div>  

                 </div>

                 <div class="content-section contentmiddle borderedbox">
                    
                     <div class="boxtitle"><img src="../../images/profile/about.png" />Your Postings</div>
                     {jobList.length==0 && 
                     
                      <div>You have not posted any jobs yet</div>
                      
                     }
                     <div class="listingsapplicants">
                     {jobList.map((item, i) => { 

                         return (
                         <div class="eachapplicantrow">

                         <div class="iconbag_jobs"><img src="../../images/ins/experience.png"/></div>
                         <div class="jobdetail">
                               <div class="jobname">{item.job_title} <span className={item.job_status==3?"jobsaved":"jobactive"}>{item.job_status==3?"Draft":"Active"}</span></div>
                               <div class="jobclass">{item.job_location}</div>
                               <div class="jobattributes tags">
                                   <span class="tag">{item.job_category}</span>
                                   <span class="tag">{item.experience}</span>
                                    
                               </div>
                         </div>

                         <div class="buttonsec_sm">
                             <div><a href={'/partner/wiseconnect/applicants/'+item.id} class="btn btn-white-full">{item.totalapplied} Applicants</a></div>
                             <div><a href={'/partner/wiseconnect/viewjob/'+item.id} class="btn btn-main-full">Manage</a></div>
                         </div>  

                         
                         </div>
                         )


                       }) }
                           
                      </div>
                                         


                 </div>


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Wcdashboard;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/dashboard.jsx